import qs from 'query-string';
import { AxiosRequestConfig } from 'axios';

import SuperFetchV2 from '../../superFetchV2';
import { GetEventListRequestType } from '../../../types/query/event/list';
import {
  EventsCreateRequestBodyDto,
  EventsFindOneResponseBodyDto,
  EventsFindResponseBodyDto,
  EventsUpdateRequestBodyDto,
} from '../../../types/api/events';

class EventApiV2 {
  /**
   * [기획전] 기획전 리스트 조회
   */
  getEventList = (
    data: GetEventListRequestType,
    config?: AxiosRequestConfig,
  ): Promise<EventsFindResponseBodyDto> =>
    SuperFetchV2.get(`/events?${qs.stringify(data, { skipNull: true, skipEmptyString: true })}`, config);

  /**
   *  기획전 등록하기
   */
  insertEvent = (data: EventsCreateRequestBodyDto) => SuperFetchV2.post('/events', data);

  /**
   *  기획전 편집하기
   */
  editEvent = ({ id, data }: { id: string; data: EventsUpdateRequestBodyDto }) =>
    SuperFetchV2.put(`/events/${id}`, data);

  /**
   *  기획전 상세 가져오기
   */
  getEventDetail = (id: number): Promise<EventsFindOneResponseBodyDto> => SuperFetchV2.get(`/events/${id}`);
}

export default new EventApiV2();
